// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__uAJAH","NavLogo":"NavBar_NavLogo__IQqPK","NavBarBurger":"NavBar_NavBarBurger__fHEyB","NavBarDesktop":"NavBar_NavBarDesktop__difod"};